<template>
  <span v-if="isMultiUser">
    <v-btn color="primary" dark class="mr-4" :loading="opening" @click="open">
      {{ $t("multiUser.button") }}
      <v-icon right dark>mdi-swap-horizontal</v-icon>
    </v-btn>
    <multiUserDialog
      v-model="dialogOpen"
      entityType="asaMeeting"
      :availableItems="items"
      itemText="label"
      itemValue="_id"
      :clients="clients"
      :currentClientId="currentClientId"
      entityLabel="multiUser.dialog.asaMeetings"
      @confirm="transfer"
    />
  </span>
</template>

<script>
import multiUserDialog from "../../components/_utils/dataTableHelpers/actions/multiUserDialog.vue";

export default {
  name: "asaMeetingTransfer",
  components: { multiUserDialog },
  props: ["year"],
  data: () => ({
    isMultiUser: false,
    currentClientId: "",
    dialogOpen: false,
    opening: false,
    clients: [],
    items: [],
  }),
  async created() {
    const user = await this.$store.dispatch("getUserInfo");
    this.isMultiUser = user?.role === "MultiUser";
    this.currentClientId = user?.client?._id || "";
  },
  methods: {
    formatDate(value) {
      if (!value) return "";
      return new Date(value).toLocaleDateString("de-DE", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    },
    async open() {
      this.opening = true;
      try {
        const [clients, meetings] = await Promise.all([
          this.$store.dispatch("getTransferClients"),
          this.$store.dispatch("getAsaMeetings", this.year),
        ]);
        this.clients = (clients && clients.data) || [];
        this.items = (meetings || []).map((m) => ({
          _id: m._id,
          label: `${this.formatDate(m.date)} – ${m.title || this.$t("sidebar.asaMeetings")}`,
        }));
        this.dialogOpen = true;
      } catch (e) {
        this.$store.dispatch("triggerError", e);
      } finally {
        this.opening = false;
      }
    },
    async transfer(payload) {
      try {
        const result = await this.$store.dispatch("transferEntities", payload);
        const parts = [];
        if (result.totalSuccess > 0) {
          parts.push(this.$t("multiUser.result.success", { number: result.totalSuccess }));
        }
        const failed = result.totalConflict + result.totalError;
        if (failed > 0) {
          parts.push(this.$t("multiUser.result.error", { number: failed }));
        }
        this.$store.commit("CREATE_SNACKBAR", parts.join(" · "));
        if (payload.action === "move" && result.totalSuccess > 0) {
          this.$emit("transferred");
        }
      } catch (e) {
        this.$store.dispatch("triggerError", e);
      }
    },
  },
};
</script>
